import axios from "axios";

let baseUrl = "https://www.tipddy.cl/wp-json/v2/public";

export const wordpresstoken = async () => {
  try {
    let { data } = await axios.post(
      "https://www.tipddy.cl/wp-json/jwt-auth/v1/token",
      {
        username: "bill",
        password: "A_gu_23da_DATA",
      },
      {
        headers: {
          "Content-type": "application/json",
        },
      }
    );
    console.log(data.token)
    return data.token;
  } catch (err) {
    throw new Error(err);
  }
};

export const fetchClientsIds = async ({ token }) => {
  try {
    let { data } = await axios.get(`${baseUrl}/clients`, {
      headers: {
        Authorization: `Bearer ${token}}`,
      },
    });
    return data.result;
  } catch (err) {
    throw new Error(err);
  }
};

export const fetchConfig = async ({ id, token }) => {
  try {
    let { data } = await axios.get(`${baseUrl}/client/${id}`, {
      headers: {
        Authorization: `Bearer ${token}}`,
      },
    });
    console.log(data.result)
    return data.result;
  } catch (err) {
    throw new Error(err);
  }
};

export const fetchClientAndToken = async (id=false) => {
  console.log(window.location.host)

  try{
    let response = await axios.get(`${baseUrl}/client/tk`, 
    {
        headers: {
          'Content-type': 'application/json'
        },
        params: {
          domain: "https://participantes.inatrans.cl",// window.location.host,
          id:id
        }
  });
  console.log(response.data.result)
  return response.data.result;
  } catch (err) {
    throw new Error(err);
  }
}